import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Carousel, notification } from 'antd';

import Urls from '../apis/Urls';
import { MgeLayout } from '../components/layout/MgeLayout';
import { EntryItem } from '../components/index/EntryItem';
import { EntryWrapper } from '../components/index/EntryWrapper';
import { CarouselWrapper } from '../components/index/CarouselWrapper';
import { SwitchButton } from '../components/index/SwitchButton';
import { Line } from '../components/index/line';
import { Banner } from '../components/index/Banner';

const btn1 = require('../img/btn1.png');
const btn2 = require('../img/btn2.png');
const btn3 = require('../img/btn3.png');
const btn4 = require('../img/btn4.png');
const xrd = require('../img/xrd.png');
const mtm = require('../img/mtm.png');

import Cookie from 'js-cookie';

class IndexEntry extends Component {

  private slider?: Carousel;

  componentDidMount() {
    const readCookieName = 'mge_notification'; 
    notification.config({
      placement: 'bottomRight'
    });
    if (Cookie.get(readCookieName) !== '1'){
      notification.open({
        message: '通告',
        description: (
          <ol>
            <li>
                材料基因工程专用数据库平台使用过程中，如有任何问题，可通过反馈按钮进行在线咨询联系我们
            </li>
            <li>
                由于用户管理权限的改变，所有用户请通过反馈按钮向用户管理员反馈所需权限，用户管理员审核之后赋予相关权限
            </li>
            <li>
                温馨提示：拥有模板管理员权限的老师请您及时审核模板，谢谢！在<b>2019年1月20日</b>后，未审核通过的模板将无法上传数据，也无法通过模板高级检索相关数据，给您带来的不便敬请谅解
            </li>
          </ol>
        ),
        onClose: () => {
          Cookie.set(readCookieName, '1')
        }
      });
    }
  }

  render() {
    return (
      <MgeLayout indexOnly titleID='MGED' defaultTitle='材料基因工程专用数据库'>
        <Banner />
        <CarouselWrapper>
          <SwitchButton position='left' onClick={() => { if (this.slider) this.slider.prev() }} />
          <SwitchButton position='right' onClick={() => { if (this.slider) this.slider.next() }} />
          <Line />
          <Carousel ref={(ref) => { this.slider = ref! }} autoplay dots={false}>
            <div>
              <EntryWrapper>
                <EntryItem
                  img={btn1}
                  url='//matcloud.mgedata.cn/'
                  titleEn='High-Throughput Computational Engine'
                  titleZh='材料高通量第一性原理计算引擎' />
                <EntryItem
                  img={btn2}
                  url='http://apot.mgedata.cn/InteratomicPotentials/'
                  titleEn='Interatomic Potentials Database'
                  titleZh='原子势库' />
                <EntryItem
                  img={btn3}
                  url={Urls.search.index}
                  titleEn='Materials Database'
                  titleZh='材料数据库' />
                <EntryItem
                  img={btn4}
                  url='http://ocpmdm.mgedata.cn/'
                  titleEn='Materials Data Mining System'
                  titleZh='材料数据挖掘系统' />
              </EntryWrapper>
            </div>
            <div>
              <EntryWrapper>
                <EntryItem
                  img={btn3}
                  url={Urls.search.index}
                  titleEn='Materials Database'
                  titleZh='材料数据库' />
                <EntryItem
                  img={btn4}
                  url='//ocpmdm.mgedata.cn/'
                  titleEn='Materials Data Mining System'
                  titleZh='材料数据挖掘系统' />
                <EntryItem
                  img={xrd}
                  url={Urls.app_entrance}
                  titleEn='High-throughput Experimental Data Processing Software'
                  titleZh={<span>高通量实验数据<br />处理软件包</span>} />
                <EntryItem
                  img={mtm}
                  url='http://mtm.mgedata.cn/index/showTable/'
                  titleEn='Paper Information Assisted Extraction Software'
                  titleZh='论文信息辅助提取软件' />
              </EntryWrapper>
            </div>
          </Carousel>
        </CarouselWrapper>
      </MgeLayout>
    );
  }
}

ReactDOM.render(<IndexEntry />, document.getElementById('wrap'));
